import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import styled from 'styled-components'
import { Link } from 'gatsby-plugin-intl'
import { breakpoints } from '../utils/utils'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'

export default props => {

    const ArrowLeft = props => {
        const { className, style, onClick } = props;

        return (
            <IoIosArrowForward
                className={className}
                role="button"
                aria-labelledby="control-button"
                aria-hidden="true"
                tabIndex="0"
                style={{ ...style }}
                onClick={onClick}
                onKeyDown={onClick}
            />
        )
    }

    const ArrowRight = props => {
        const { className, style, onClick } = props;

        return (
            <IoIosArrowBack
                className={className}
                role="button"
                aria-labelledby="control-button"
                aria-hidden="true"
                tabIndex="0"
                style={{ ...style }}
                onClick={onClick}
                onKeyDown={onClick}
            />
        )
    }

    const settings = {
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: <ArrowLeft />,
        prevArrow: <ArrowRight />,
        infinite: false,
        responsive: [
            {
              breakpoint: 901,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
        ]
    }

    
    const slides = props.data && props.data.edges

    return (
        <SliderBlog {...settings}>
            {
                slides && slides.map( slide => {

                    const { id, picture, slug, title } = slide.node

                    return (
                        <Slide key={id}>
                            <Link to={(`/${props.locale}/${slug}`).toLowerCase().trim()}>
                                <div>
                                    {picture && picture.file ?
                                        <img src={picture.file.url} alt={title} />
                                    :
                                        <></>
                                    }
                                    <p>{title}</p>
                                </div>
                            </Link>
                        </Slide>
                    )
                })
            }
        </SliderBlog>
    )
}
const Slide = styled.div`
    margin-bottom: 2rem;
    a {
        text-decoration: none;
    }
    div {
        &:hover {
            transform: scale(1.02);
        }

        img {
            width: auto;
            max-width: 90%;
            height: 220px;
            margin: 0 auto;
            object-fit: cover;
            box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
            ${breakpoints.md}{
                width: 80%;
                height: auto;
            }
        }
    
        p {
            font-size: 1.6rem;
            font-weight: bold;
            margin: .5rem 0;
            color: #1D0E5C;
            text-align: center;
        }
    }
`
const SliderBlog = styled(Slider)`
    max-width: 900px;
    width: 100%;
    margin: auto;
    ${breakpoints.md}{
        max-width: 70%;
    }

    .slick-prev, .slick-next {
        color: #000!important;
        height: 3rem!important;
        width: 3rem!important;
    }
`